import { usePasteConfig } from '@/components/custom/erp/input-table-v2';

interface UseTSCCPasteProps {
  columns: MuaHangRecord[];
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (
    configs: Record<string, { resolver: (codes: string[]) => Promise<MuaHangRecord[]>; resultField?: string }>
  ) => void;
}

export const useTSCCPaste = ({
  columns,
  handleUpdateNonWritableFields,
  handleUpdatePasteConfigs
}: UseTSCCPasteProps) => {
  return usePasteConfig({
    columns,
    onNonWritableFields: handleUpdateNonWritableFields,
    onPasteConfigs: handleUpdatePasteConfigs
  });
};
